import CountryPageRenderer from '../components/CountryPageRenderer';
import portugalData from '../data/country-pages/portugal';

export default function PortugalCountryPage() {
  return <CountryPageRenderer data={portugalData} />;
}
